var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('complaint-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }